module.exports = __webpack_public_path__ + "img/billIcon1.ec9343c2.png";